const chatHeaderTestIdPrefix = 'rovo-chat-header';

export const chatHeaderTestIds = {
	container: `${chatHeaderTestIdPrefix}-container`,
	backButton: `${chatHeaderTestIdPrefix}-back-button`,
	menuButton: `${chatHeaderTestIdPrefix}-menu-button`,
	newChatButton: `${chatHeaderTestIdPrefix}-new-chat-button`,
	moreMenuPopup: `${chatHeaderTestIdPrefix}-more-menu-popup`,
	switchModeButton: `${chatHeaderTestIdPrefix}-switch-mode-button`,
	splitLayoutButton: `${chatHeaderTestIdPrefix}-split-layout-button`,
	fullScreenButton: `${chatHeaderTestIdPrefix}-fullscreen-button`,
	feedbackButton: `${chatHeaderTestIdPrefix}-feedback-button`,
	getHelpButton: `${chatHeaderTestIdPrefix}-get-help-button`,
	debugButton: `${chatHeaderTestIdPrefix}-debug-button`,
	renameButton: `${chatHeaderTestIdPrefix}-rename-button`,
	deleteButton: `${chatHeaderTestIdPrefix}-delete-button`,
	miniModalButton: `${chatHeaderTestIdPrefix}-mini-modal-button`,
	sidebarButton: `${chatHeaderTestIdPrefix}-sidebar-button`,
	fullScreenModalButton: `${chatHeaderTestIdPrefix}-full-screen-modal-button`,
	moreMenuButton: `${chatHeaderTestIdPrefix}-more-menu-button`,
	closeButton: `${chatHeaderTestIdPrefix}-close-button`,
	desktopAppButton: `${chatHeaderTestIdPrefix}-desktop-app-button`,
	slackAppButton: `${chatHeaderTestIdPrefix}-slack-app-button`,
	teamsAppButton: `${chatHeaderTestIdPrefix}-teams-app-button`,
	chromeExtensionButton: `${chatHeaderTestIdPrefix}-chrome-extension-button`,
	cliButton: `${chatHeaderTestIdPrefix}-cli-button`,
	mobileAppButton: `${chatHeaderTestIdPrefix}-mobile-app-button`,
	moreMenuBackButton: `${chatHeaderTestIdPrefix}-more-menu-back-button`,
	storeMessagesCheckbox: `${chatHeaderTestIdPrefix}-store-messages-checkbox`,
	sitePickerMenuItem: `${chatHeaderTestIdPrefix}-site-picker-menu-item`,
	settingsButton: `${chatHeaderTestIdPrefix}-settings-button`,
	whatsNewButton: `${chatHeaderTestIdPrefix}-whats-new-button`,
	shareButton: `${chatHeaderTestIdPrefix}-share-button`,
	moreMenuPostOfficeSpotlightWrapper: `${chatHeaderTestIdPrefix}-more-menu-post-office-spotlight-wrapper`,
};
